import React, { memo } from 'react';
import EdgeInsertButton from './EdgeInsertButton';
import { EDGE_INSERT_ZONE_LENGTH, EDGE_INSERT_ZONE_WIDTH, layoutEdgeInsert } from '../utils/edgeInsertLayout';

/**
 * (+) buttons along edges. Hidden while a node is being dragged.
 */
function EdgeInsertButtons({
  containerRef,
  flowchartRef,
  isDragging,
  edges,
  panRef,
  zoomRef,
  canvasToScreen,
  hoveredEdgeId,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) {
  const containerRect = flowchartRef?.current?.getBoundingClientRect();

  return (
    <div ref={containerRef} className="handles-layer__edge-buttons" style={{ display: isDragging ? 'none' : undefined }}>
      {edges.map((edge) => {
        const layout = layoutEdgeInsert(edge, {
          pan: panRef.current,
          zoom: zoomRef.current,
          containerRect,
          canvasToScreen,
        });
        if (!layout) return null;

        return (
          <EdgeInsertButton
            key={`insert-btn-${edge.id}`}
            edge={edge}
            screenPos={layout.screenPos}
            midpoint={layout.midpoint}
            visualOffsetX={layout.visualOffsetX}
            visualOffsetY={layout.visualOffsetY}
            zoneMidX={layout.zoneMidX}
            zoneMidY={layout.zoneMidY}
            zoneLength={EDGE_INSERT_ZONE_LENGTH}
            zoneWidth={EDGE_INSERT_ZONE_WIDTH}
            zoneAngleDeg={layout.zoneAngleDeg}
            isHovered={hoveredEdgeId === edge.id}
            onClick={onClick}
            onMouseEnter={() => onMouseEnter(edge.id)}
            onMouseLeave={onMouseLeave}
          />
        );
      })}
    </div>
  );
}

export default memo(EdgeInsertButtons);
